import $ from 'jquery';

exports.init = () => {

	$(document)
		// menu
		.on('change', '[name="pricing"]', function(e) {
			$('.b-price').toggleClass('is-recalculate');
		});

};



// WEBPACK FOOTER //
// ./src/js/components/priceToggle.js